var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.53 21.4702C6.02 21.4702 1.53 16.9802 1.53 11.4702C1.53 5.96021 6.02 1.47021 11.53 1.47021C17.04 1.47021 21.53 5.96021 21.53 11.4702C21.53 16.9802 17.04 21.4702 11.53 21.4702ZM11.53 3.47021C7.12 3.47021 3.53 7.06021 3.53 11.4702C3.53 15.8802 7.12 19.4702 11.53 19.4702C15.94 19.4702 19.53 15.8802 19.53 11.4702C19.53 7.06021 15.94 3.47021 11.53 3.47021Z",
    fill: "#161A49"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M10.99 11.7799C10.4 11.7799 9.91 11.2999 9.91 10.6999C9.91 10.0999 10.39 9.62988 10.99 9.62988C11.59 9.62988 12.06 10.1099 12.06 10.6999C12.06 11.2899 11.58 11.7799 10.99 11.7799ZM10.99 9.77988C10.48 9.77988 10.06 10.1999 10.06 10.6999C10.06 11.1999 10.48 11.6299 10.99 11.6299C11.5 11.6299 11.91 11.2099 11.91 10.6999C11.91 10.1899 11.49 9.77988 10.99 9.77988Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.53 16.7799C10.98 16.7799 10.53 16.3299 10.53 15.7799V11.6899C10.53 11.6899 10.52 11.6899 10.51 11.6899C9.99 11.4899 9.74 10.9099 9.93 10.3999C10.06 10.0599 10.33 9.79987 10.68 9.66987C11.06 9.53987 11.51 9.56987 11.85 9.76987C12.28 10.0199 12.52 10.4899 12.52 11.0599V15.7899C12.52 16.3399 12.07 16.7899 11.52 16.7899L11.53 16.7799Z",
    fill: "#161A49"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9 17.4002C11.66 17.4002 11.41 17.3402 11.21 17.2202C10.78 16.9702 10.54 16.5002 10.54 15.9302V11.2002C10.54 10.6502 10.99 10.2002 11.54 10.2002C12.09 10.2002 12.54 10.6502 12.54 11.2002V15.2902C12.54 15.2902 12.55 15.2902 12.56 15.2902C13.08 15.4902 13.33 16.0702 13.14 16.5802C13.01 16.9202 12.74 17.1802 12.39 17.3102C12.24 17.3602 12.08 17.3902 11.92 17.3902L11.9 17.4002Z",
    fill: "#161A49"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.52 8.08008C12.2103 8.08008 12.77 7.52043 12.77 6.83008C12.77 6.13972 12.2103 5.58008 11.52 5.58008C10.8296 5.58008 10.27 6.13972 10.27 6.83008C10.27 7.52043 10.8296 8.08008 11.52 8.08008Z",
    fill: "#161A49"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/Info.b0d317964424b96fc63fba71ef50eb41.svg";
export { ForwardRef as ReactComponent };